export default __webpack_public_path__ + "static/media/live_sessions_logo.ea3f4d4b.png";